export default __webpack_public_path__ + "static/media/ea-loginbg.92ec4051.jpg";